import { Link } from "react-router-dom";

interface ChapterNavProps {
  comicId: string;
  chapters: Array<{
    id: string;
    title: string;
    number: number;
  }>;
  currentChapterId: string;
}

export default function ChapterNav({ comicId, chapters, currentChapterId }: ChapterNavProps) {
  const currentIndex = chapters.findIndex((ch) => ch.id === currentChapterId);
  const prevChapter = currentIndex > 0 ? chapters[currentIndex - 1] : null;
  const nextChapter = currentIndex < chapters.length - 1 ? chapters[currentIndex + 1] : null;

  return (
    <div className="max-w-2xl mx-auto px-4">
      <div className="flex items-center justify-between gap-3 py-4 border-t border-background-200">
        {prevChapter ? (
          <Link
            to={`/article/${comicId}?chapter=${prevChapter.id}`}
            className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-s-line"></i>
            </div>
            上一章
          </Link>
        ) : (
          <div />
        )}

        <div className="relative">
          <select
            className="appearance-none px-4 py-2 pr-8 rounded-full bg-background-100 text-sm text-foreground-700 outline-none cursor-pointer border border-background-200 hover:border-primary-300 transition-colors"
            value={currentChapterId}
            onChange={(e) => {
              const val = e.target.value;
              if (val !== currentChapterId) {
                window.REACT_APP_NAVIGATE(`/article/${comicId}?chapter=${val}`);
              }
            }}
          >
            {chapters.map((ch) => (
              <option key={ch.id} value={ch.id}>
                {ch.title}
              </option>
            ))}
          </select>
          <div className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center pointer-events-none">
            <i className="ri-arrow-down-s-line text-foreground-500"></i>
          </div>
        </div>

        {nextChapter ? (
          <Link
            to={`/article/${comicId}?chapter=${nextChapter.id}`}
            className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            下一章
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}